// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function execute(json) {
  var dict = Belt_Option.getExn(Js_json.decodeObject(json));
  var decodedName = Belt_Option.getExn(Js_json.decodeString(Belt_Option.getExn(Js_dict.get(dict, "name"))));
  var decodedMessage = Belt_Option.getExn(Js_json.decodeString(Belt_Option.getExn(Js_dict.get(dict, "message"))));
  return {
          message: decodedMessage,
          name: decodedName
        };
}

export {
  execute ,
}
/* No side effect */
